import React from 'react';

// Nota discreta do mesmo autor, só depois de um resultado completo (renderizada no cliente:
// não entra no HTML servido nem na contagem de links da página). Sem dado do escore na URL.
const LinksDoctorNote = ({ show, source = 'home' }) => {
  if (!show) return null;
  return (
    <p className="ld-nota">
      Também atende em consultório? O{' '}
      <a
        href={`https://links.doctor/?utm_source=escaladeglasgow&utm_medium=calculadora&utm_campaign=linksdoctor-cta&utm_content=${source}`}
        target="_blank"
        rel="nofollow noopener"
      >
        links.doctor
      </a>{' '}
      reúne WhatsApp, endereço, agendamento e CRM numa página que o paciente abre pelo celular. 30 dias grátis.
    </p>
  );
};

export default LinksDoctorNote;
